module.exports = __webpack_public_path__ + "img/4.c8e229e3.png";